import { useRoutes } from "react-router-dom";
import ModuleWrap from "../components/ModuleWrap";

import AuthLayout from "../views/layouts/AuthLayout";
import MainLayout from "../views/layouts/MainLayout";

import Login from "../views/modules/Auth/Login/Login";
import PageNotFound from "../views/errors/PageNotFound";

import Dashboard from "../views/modules/Dashboard";
import UserManagement from "../views/modules/UserManagement";
import RoleManagement from "../views/modules/RoleManagement";
import ResetPassword from "../views/modules/Auth/ResetPassword/ResetPassword";
import ForgotPassword from "../views/modules/Auth/ForgotPassword/ForgotPassword";
import Cms from "../views/modules/Setting/Cms";
import LandingPage from "../views/modules/Setting/LandingPage";
import Profile from "../views/modules/Profile";
import RaceManagement from "../views/modules/RaceManagement";
import VeteranStatusManagement from "../views/modules/VeteranStatusManagement";
import VrTrainingLocation from "../views/modules/VrTrainingLocation";
import InterestDiscovery from "../views/modules/InterestDiscovery";
import SkillPortrait from "../views/modules/SkillPortrait";
import Testimonial from "../views/modules/Testimonial";
import CareerCategoriesManagement from "../views/modules/CareerCategories";
import CareerManagement from "../views/modules/Careers";
import CertificationsManagement from "../views/modules/Certifications";
import OccupationalGroupsManagement from "../views/modules/OccupationalGroups";
import SkillCategoriesManagement from "../views/modules/SkillCategories";
import EducationTrainingManagement from "../views/modules/EducationTraining";
import ExperienceManagement from "../views/modules/Experience";
import CareerPathManagement from "../views/modules/CareerPath";
import CustomerAccess from "../views/modules/CustomerAccess";
import Company from "../views/modules/Company";
import CreatePassword from "../views/modules/Auth/CreatePassword/CreatePassword";

import CurriculumDetailsComponent  from "../views/modules/Cucurriculum/components/CurriculumDetailsComponent";
import Industry from "../views/modules/Industry";

import Acronyms from "../views/modules/Acronyms";

import CustomerDashboard from "../views/modules/Dashboard/CustomerDashboard";
import AdminDashboard from "../views/modules/Dashboard/AdminDashboard";
import CareerGroup from "../views/modules/CareerGroup";
import ImportActivity from "../views/modules/ImportActivity";
import ActivityLog from "../views/modules/ActivityLog";
import React from "react";
export default function Router() {
  return useRoutes(RouterConfig);
}

export const RouterConfig = [
  {
    element: <AuthLayout />,
    children: [
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/forgot-password",
        element: <ForgotPassword />,
      },
      {
        path: "/reset/:otp",
        element: <ResetPassword />,
      },
      {
        path: "/create-password/:user_id",
        element: <CreatePassword />,
      },
    ],
  },
  {
    element: <MainLayout />,
    children: [
      {
        path: "/",
        element: <ModuleWrap module={AdminDashboard} permission={""} />,
      },
      {
        path: "/customer/dashboard",
        element: <ModuleWrap module={CustomerDashboard} permission={""} />,
      },
      {
        path: "/profile",
        element: <ModuleWrap module={Profile} permission={""} />,
      },
      {
        path: "/ethnicities",
        element: <ModuleWrap module={RaceManagement} permission={""} />,
      },
      {
        path: "/military-status",
        element: (
          <ModuleWrap module={VeteranStatusManagement} permission={""} />
        ),
      },
      {
        path: "/users",
        element: <ModuleWrap module={UserManagement} permission={""} />,
      },
      {
        path: "/roles",
        element: <ModuleWrap module={RoleManagement} permission={""} />,
      },
      {
        path: "/settings/home-page",
        element: <ModuleWrap module={LandingPage} permission={""} />,
      },
      {
        path: "/settings/cms",
        element: <ModuleWrap module={Cms} permission={""} />,
      },
      {
        path: "/locations",
        element: <ModuleWrap module={VrTrainingLocation} permission={""} />,
      },
      {
        path: "/interest-discovery",
        element: <ModuleWrap module={InterestDiscovery} permission={""} />,
      },
      {
        path: "/skill-portrait",
        element: <ModuleWrap module={SkillPortrait} permission={""} />,
      },
      {
        path: "/testimonial",
        element: <ModuleWrap module={Testimonial} permission={""} />,
      },
      {
        path: "/career-categories",
        element: (
          <ModuleWrap module={CareerCategoriesManagement} permission={""} />
        ),
      },
      {
        path: "/career",
        element: <ModuleWrap module={CareerManagement} permission={""} />,
      },
      {
        path: "/certifications",
        element: (
          <ModuleWrap module={CertificationsManagement} permission={""} />
        ),
      },
      {
        path: "/occupational-groups",
        element: (
          <ModuleWrap module={OccupationalGroupsManagement} permission={""} />
        ),
      },
      {
        path: "/skill-categories",
        element: (
          <ModuleWrap module={SkillCategoriesManagement} permission={""} />
        ),
      },
      {
        path: "/education-training",
        element: (
          <ModuleWrap module={EducationTrainingManagement} permission={""} />
        ),
      },
      {
        path: "/experience",
        element: <ModuleWrap module={ExperienceManagement} permission={""} />,
      },
      {
        path: "/career-path",
        element: <ModuleWrap module={CareerPathManagement} permission={""} />,
      },
      {
        path: "/customer-access",
        element: <ModuleWrap module={CustomerAccess} permission={""} />,
      },
      {
        path: "/customer",
        element: <ModuleWrap module={Company} permission={""} />,
      },
      {
        path: "/industries",
        element: <ModuleWrap module={Industry} permission={""} />,
      },
      {
        path: "/acronyms",
        element: <ModuleWrap module={Acronyms} permission={""} />,
      },
      {
        path: "/curriculum/:id",
        element: <ModuleWrap module={CurriculumDetailsComponent} permission={""} />,
      },
      {
        path: "/career-group",
        element: <ModuleWrap module={CareerGroup} permission={""} />,
      },
      {
        path: "/import-activity",
        element: <ModuleWrap module={ImportActivity} permission={""} />,
      },
      {
        path: "/activity-log",
        element: <ModuleWrap module={ActivityLog} permission={""} />,
      },
     ],

  },
  {
    path: "*",
    element: <PageNotFound />,
  },
];
